import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Assurance, Site } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';
import { RenvoiCompagnieData } from '../model/Suivi';

@Injectable({
  providedIn: 'root',
})
export class SuiviService {

  constructor(
    private http : HttpClient,
    private dbConnection : DatabaseConnection
  ){}

  assurances(){
    return this.http.get<Assurance[]>(this.dbConnection.remoteApiConnection.value + 'liste-assurances-rapport');
  }

  bureaux(){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'liste-validation-rapport');
  }

  bureauxGroupe(groupe ?: string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'liste-validation-rapport?groupe='+groupe+"&validation="+true);
  }

  groupes(){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'liste-reception-rapport');
  }

  listValidationRapportBureaux(id : string){
    return this.http.get<{assurance : Assurance[], bureau : Site}>(this.dbConnection.remoteApiConnection.value + 'liste-validation-rapport/'+id);
  }


  validation(data : Object[]){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'validation-rapport', {rapport : data});
  }

  listReceptionRapportBureaux(id : string){
    return this.http.get<{assurance : Assurance[], bureau : Site}>(this.dbConnection.remoteApiConnection.value + 'liste-reception-rapport/'+id);
  }

  reception(data : Object[]){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'reception-rapport', {rapport : data});
  }


  transmission(data : Object[]){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'transmission-rapport', {rapport : data})
  }

  renvoiCompagnie(){
    return this.http.get<RenvoiCompagnieData[]>(this.dbConnection.remoteApiConnection.value + 'renvoi-compagnie')
  }

  renvoiCompagnieDetails(compagnie : string, collab : string){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'renvoi-compagnie-details', {compagnie : compagnie, collaborateur : collab})
  }

  renvoiDocuments(data : any[]){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'renvoi-documents', { documents : data })
  }

  historiqueRenvoi(){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'renvoi-histo')
  }
}
